import { FullStory, init } from '@fullstory/browser';
import environment from '@lib/environment';
import { setContext } from '@sentry/react';

import appManager from '../../app/appManager';
import AppModule from '../../app/lib/AppModule';
import { AuthUser } from '../AuthModule/lib/types';

export class FullStoryModule extends AppModule {
  override preload(): void {
    this.app.events.on('app.started', () => {
      if (environment.FULLSTORY_ORG_ID) {
        init(
          {
            devMode: environment.MODE !== 'production',
            orgId: environment.FULLSTORY_ORG_ID,
          },
          ({ sessionUrl }) => {
            setContext('FullStory', { sessionUrl });
          },
        );
        this.app.logger.info('initialized');
      }
    });

    this.app.events.on('auth.signin', (user: AuthUser) => {
      if (environment.FULLSTORY_ORG_ID) {
        FullStory('setIdentity', {
          uid: user.id,
          properties: {
            displayName: user.name,
            service: user.contactCenterId,
          },
        });
        this.app.logger.info('user identified: ', user.id);
      }
    });
  }
}

export default new FullStoryModule(
  appManager.events,
  appManager.logger('FullStory'),
);
